import React, { useEffect, useRef, useState } from "react";
import { GET_EVENTS_SEASON_ANCHORED } from "../../stages/queries/GetGames";
import { useLazyQuery } from "@apollo/client";
import GameElement from "../../game/GameElement";
import TrainingElement from "../../game/TrainingElement";
import PaginatedFlatTable from "../../pagination/PaginatedFlatTable";

const PAGE_SIZE = 25;

export default function OrgPortalScheduleTab({ games = [], activeSeasonData, hideActions = true }) {
    const [getEvents, { data, loading, error }] = useLazyQuery(GET_EVENTS_SEASON_ANCHORED);
    const [events, setEvents] = useState([]);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(1);
    const lastRequestKeyRef = useRef("");

    useEffect(() => {
        if (activeSeasonData?.slug) {
            const requestKey = `${activeSeasonData.slug}:1`;
            if (lastRequestKeyRef.current === requestKey) return;
            lastRequestKeyRef.current = requestKey;
            getEvents({
                variables: {
                    seasonSlug: activeSeasonData.slug,
                    stageId: null,
                    page: 1,
                    pageSize: PAGE_SIZE,
                    anchorDate: new Date().toISOString(),
                },
            });
        }
    }, [activeSeasonData?.slug, getEvents]);

    useEffect(() => {
        if (data?.eventsBySeason?.objects) {
            setEvents(data.eventsBySeason.objects);
            setPages(data.eventsBySeason.pages || 1);
            setPage(data.eventsBySeason.page || 1);
        }
    }, [data]);

    const handlePageChange = (newPage) => {
        if (activeSeasonData?.slug) {
            const requestKey = `${activeSeasonData.slug}:${newPage}`;
            if (lastRequestKeyRef.current === requestKey) return;
            lastRequestKeyRef.current = requestKey;
            getEvents({
                variables: {
                    seasonSlug: activeSeasonData.slug,
                    stageId: null,
                    page: newPage,
                    pageSize: PAGE_SIZE,
                    anchorDate: new Date().toISOString(),
                },
            });
        }
    };

    if (loading) {
        return <div>Loading schedule...</div>;
    }

    if (error) {
        return <div>Error loading schedule</div>;
    }

    const displayEvents = events.length > 0 ? events : games;

    return (
        <PaginatedFlatTable
            title=""
            page={page}
            pages={pages}
            onPageChange={handlePageChange}
            items={displayEvents}
            loading={loading}
            loadingOverlay
            showPageNumbers
            pageWindow={2}
            headers={[]}
            renderRow={(event, idx) => {
                if (event?.eventType === "GAME") {
                    return (
                        <GameElement
                            key={`game_element_${event.id}_${idx}`}
                            event={event}
                            stages={[]}
                            referees={[]}
                            games={displayEvents}
                            updateScore={() => {}}
                            handleRemoveGame={() => {}}
                            hideActions={hideActions}
                            canEdit={false}
                        />
                    );
                }

                if (event?.eventType === "TRAINING") {
                    return (
                        <TrainingElement
                            key={`training_${event.id}_${idx}`}
                            event={event}
                            handleRemoveEvent={() => {}}
                            onEdit={() => {}}
                            hideActions={hideActions}
                        />
                    );
                }

                return null;
            }}
        />
    );
}
